/*
 * @Description:全局状态管理
 * @Author: kai.zhou
 * @Date: 2020-03-25 14:39:19
 * @LastEditors: kai.zhou
 * @LastEditTime: 2021-04-25 20:35:56
 */
import { createStore, combineReducers } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import session from "redux-persist/lib/storage/session";

//定义初始化数据
const initData = {
  everyThingDoFirst: false, //必须点击一下才能使用各项功能
};

//必须点击一下才能使用各项功能
export const setEveryThingDoFirst = (v: any) => {
  return { type: "setEveryThingDoFirst", data: v };
};

//定义action触发state改变
const blacklistState = (state: any = initData, action: any) => {
  switch (action.type) {
    case "setEveryThingDoFirst":
      return { ...state, ...{ everyThingDoFirst: action.data } };
    default:
      return state;
  }
};

export const setResource = (v: any) => {
  return { type: "setResource", data: v };
};

export const setXsn = (v: any) => {
  return { type: "setXsn", data: v };
};

export const setLang = (v: any) => {
  return { type: "setLang", data: v };
};

export const setDrawCount = (v: any) => {
  return { type: "setDrawCount", data: v };
};

const defaultState = (state: any = {}, action: any) => {
  switch (action.type) {
    case "setResource":
      return { ...state, ...{ resource: action.data } };
    case "setXsn":
      return { ...state, ...{ xsn: action.data } };
    case "setLang":
      return { ...state, ...{ lang: action.data } };
    case "setDrawCount":
      return { ...state, ...{ drawCount: action.data } };
    default:
      return state;
  }
};

export const setXtoken = (v: any) => {
  return { type: "setXtoken", data: v };
};
export const setCarlcareToken = (v: any) => {
  return { type: "setCarlcareToken", data: v };
};
const sessionState = (state: any = {}, action: any) => {
  switch (action.type) {
    case "setXtoken":
      return { ...state, ...{ xtoken: action.data } };
    case "setCarlcareToken":
      return { ...state, ...{ carlcareToken: action.data } };
    default:
      return state;
  }
};

// 全局你可以创建多个reducer 在这里统一在一起
const defaultStore = combineReducers({
  blacklistState,
  defaultState,
  sessionState: persistReducer({ key: "auth", storage: session }, sessionState),
});
// 全局就管理一个store

const persistConfig = {
  key: "root",
  storage,
  blacklist: ["blacklistState", "sessionState"],
};

const persistedReducer = persistReducer(persistConfig, defaultStore);

export const store = createStore(persistedReducer);
export const persistor = persistStore(store);
